module.exports = __webpack_public_path__ + "static/overv-fca9332fa8d63be45e6d1603cc807365.png";